import SidePanel from '@/components/TreeDoc/SidePanel.jsx'
import useCommentPane from './CommentPane/useCommentPane.jsx'
import useExternalPane from './ExternalPane/useExternalPane.jsx'
import useHiddenPane from './HiddenPane/useHiddenPane.jsx'
import useImportantPane from './ImportantPane/useImportantPane.jsx'
import useInvalidPane from './InvalidPane/useInvalidPane.jsx'
import useMarkPane from './MarkPane/useMarkPane.jsx'
import useMessagePane from './MessagePane/useMessagePane.jsx'
import useSearchPane from './SearchPane/useSearchPane.jsx'
import useSettingsPane from './SettingsPane/useSettingsPane.jsx'
import useUpgradePane from './UpgradePane/useUpgradePane.jsx'

export default function LeftPanel(props) {
    const panes = [
        useSearchPane(),
        useImportantPane(),
        useCommentPane(),
        useMarkPane(),
        useMessagePane(),
        useUpgradePane(),
        useInvalidPane(),
        useExternalPane(),
        useHiddenPane(),
        useSettingsPane(),
    ]

    return (
        <SidePanel
            direction="ltr"
            panelId="left"
            panes={panes}
            {...props}
        />
    )
}
